import React from "react";
import { ClienteProdutoSelecionado } from "../Estilos";
import { useHistory } from "react-router-dom";
import { MascaraCNPJ } from "./Funcoes";

function ListaLojas({ item }) {
  const history = useHistory();
  return (
    <div>
      <ClienteProdutoSelecionado>
        <div className={"NomeCliente"}>{item.nome}</div>
        <div className={"CNPJSAP"}>
          <span>CPNJ</span> {MascaraCNPJ(item.cnpj)}
        </div>
        <div className={"CNPJSAP"}>
          <span>SAP</span> {item.sap}
        </div>
        <div className={"CNPJSAP2"}>
          <span>Período sem compra:</span> {item.periodoSemCompra} meses
        </div>
        <div className={"CNPJSAP2"}>
          <span style={{ width: "70px" }}>Produto:</span>{" "}
          {item.produtoDescricao}
        </div>
        <div
          onClick={() =>
            history.push({
              pathname: "/Recompra1500",
              state: { item },
            })
          }
          className={"BtAlterar"}
        >
          RETORNO VENDAS
        </div>
      </ClienteProdutoSelecionado>
    </div>
  );
}

export default ListaLojas;
